import { useMutation } from 'react-query'
import apiService from '../services/api'

export const useUpload = () => {
  const uploadPhoto = async args => {
    const formdata = new FormData()
    formdata.append('file', args)
    return await apiService.post('/api/v1/file', formdata)
  }

  return useMutation(uploadPhoto, {
    onError: error => {
      console.log(error)
      console.log(error?.response)
    }
  })
}
